export const DEFAULT_EDIT_VACCINE = {
  vitals_list: [
    {
      id: 1,
      name: "Height",
      value: "",
      unit: "cm",
      unitList: ["cm", "ft’in”"],
      key: "height",
    },
    {
      id: 2,
      name: "Weight",
      value: "",
      unit: "Kg",
      unitList: ["Kg", "Lbs"],
      key: "weight",
    },
    {
      id: 3,
      name: "HC",
      value: "",
      unit: "cm",
      unitList: ["cm"],
      key: "head_circumference",
    },
  ],
};
